import { useState, useEffect } from "react";
import { Input } from "antd";
import IMAGES from "../../../../constant/images";
import KycUsersFilterDrawer from "./KycUsersFilterDrawer";
import { Search, Filter } from "lucide-react";

export default function KycUsersControl({
  onSearchChange,
  filters,
  setFilters,
  setCurrentPage,
}) {
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);

  const activeFilterCount = Object.values(filters || {}).filter(
    (value) => value !== null && value !== ""
  ).length;

  const hasActiveFilters = activeFilterCount > 0;

  // Call search callback when typing (debounced)
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      onSearchChange?.(searchValue.trim());
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchValue, onSearchChange]);

  return (
    <>
      <div className="flex flex-wrap items-center justify-end gap-2 p-2">
        {/* Desktop Controls */}
        <div className="hidden md:flex items-center gap-3">
          <div className="w-[360px]">
            <Input
              type="text"
              placeholder="Search by name"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="w-full h-9 px-3 rounded-xl border-[1px] border-solid border-[#E2E8F0]
                text-[#171717] bg-white shadow-sm font-normal text-sm font-poppins focus:ring-2 focus:ring-[#B3D7FF]
                placeholder:font-normal placeholder:text-sm placeholder:text-[#94A3B8]"
              prefix={<Search size={16} className="text-[#64748B] mr-1" />}
            />
          </div>

          <button
            className="relative flex items-center gap-2 h-9 px-[14px] bg-white text-[#171717] text-[13px] font-semibold border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-sm hover:bg-[#F8FAFC] transition font-poppins"
            onClick={() => setFilterOpen(true)}
          >
            Filter
            <Filter size={14} className="text-[#2563EB]" />
            {hasActiveFilters && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                {activeFilterCount}
              </span>
            )}
          </button>
        </div>

        {/* Mobile Controls */}
        <div className="flex md:hidden items-center gap-3">
          <img
            src={IMAGES.mobile_searching_icon}
            alt="search"
            width={40}
            height={40}
            className="cursor-pointer"
            onClick={() => setMobileSearchOpen(!mobileSearchOpen)}
          />

          <div className="relative">
            <img
              src={IMAGES.mobile_filter_icon}
              alt="filter"
              width={40}
              height={40}
              className="cursor-pointer"
              onClick={() => setFilterOpen(true)}
            />
            {hasActiveFilters && (
              <span className="absolute top-0 right-0 bg-red-500 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                {activeFilterCount}
              </span>
            )}
          </div>
        </div>

        {mobileSearchOpen && (
          <div className="w-full p-2">
            <Input
              type="text"
              placeholder="Search by name"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="w-full h-9 px-3 rounded-xl border-[1px] border-solid border-[#E2E8F0]
                text-[#171717] bg-white shadow-sm font-normal text-sm font-poppins focus:ring-2 focus:ring-[#B3D7FF]
                placeholder:font-normal placeholder:text-sm placeholder:text-[#94A3B8]"
              prefix={<Search size={16} className="text-[#64748B] mr-1" />}
            />
          </div>
        )}
      </div>

      <KycUsersFilterDrawer
        filterOpen={filterOpen}
        setFilterOpen={setFilterOpen}
        filters={filters}
        setFilters={setFilters}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
}
